var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.7C15 6.68882 14.806 5.68754 14.4291 4.75334C14.0522 3.81913 13.4997 2.97029 12.8033 2.25528C12.1069 1.54027 11.2801 0.973089 10.3701 0.586128C9.46018 0.199166 8.48491 0 7.5 0C6.51509 0 5.53982 0.199166 4.62987 0.586128C3.71993 0.973089 2.89314 1.54027 2.1967 2.25528C1.50026 2.97029 0.947814 3.81913 0.570903 4.75334C0.193993 5.68754 -1.46764e-08 6.68882 0 7.7C0 9.2257 0.438214 10.6447 1.18393 11.8415H1.17536L7.5 22L13.8246 11.8415H13.8171C14.5895 10.6057 15.0001 9.1683 15 7.7ZM7.5 11C6.64752 11 5.82995 10.6523 5.22716 10.0335C4.62436 9.41458 4.28571 8.57521 4.28571 7.7C4.28571 6.82479 4.62436 5.98542 5.22716 5.36655C5.82995 4.74768 6.64752 4.4 7.5 4.4C8.35248 4.4 9.17005 4.74768 9.77284 5.36655C10.3756 5.98542 10.7143 6.82479 10.7143 7.7C10.7143 8.57521 10.3756 9.41458 9.77284 10.0335C9.17005 10.6523 8.35248 11 7.5 11Z",
    fill: "#20B2A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.00fce7cb158661d6ddb54ec8dc62434f.svg";
export { ForwardRef as ReactComponent };